import {
  pageEvent,
  trackEvent,
  waitForAnalyticsLoad,
} from '@acko-tech/building-blocks.ui.acko-analytics';
import {
  AppsFlyer,
  DOMESTIC_PASS,
  EventType,
  HindustanTimesPartner,
  TRAVEL,
  TravelPassPages,
  VAS,
  VasPages,
} from './types';
import { getUtmParams } from 'src/common/custom-hooks';
import Cookies from 'js-cookie';
import { PageType } from 'src/international-insurance/config';

declare const window: any;

export const sendSegmentEvent = (
  type: string,
  eventName: string,
  payload,
  userDetails,
  packageType = ''
) => {
  if (typeof window !== 'undefined') {
    const props = {
      product: TRAVEL.PRODUCT,
      sub_product_name: TRAVEL.SUB_PRODUCT_NAME,
      email: !!userDetails?.email ? userDetails?.email : undefined,
      phone: !!userDetails?.phone ? userDetails?.phone : undefined,
      journey: !!packageType ? PageType[packageType] : TRAVEL.JOURNEY,
      ...getUtmParams(),
      ...payload,
    };

    if (type === EventType.VIEW)
      waitForAnalyticsLoad().then(() => pageEvent(eventName, props));
    if (type === EventType.TAP) trackEvent(eventName, props);
  }
  return null;
};

export const sendVasEvents = (
  eN: string,
  eT = EventType.VIEW,
  payload: any = {},
  userDetails
) => {
  const urlParams = new URLSearchParams(window?.location?.search);
  const bookingId = urlParams?.get('booking_id');
  const orderId = urlParams?.get('order_id');

  sendSegmentEvent(
    eT,
    eN,
    {
      journey: VAS.JOURNEY,
      sub_product_name: VAS.SUB_PRODUCT_NAME,
      order_id: orderId || undefined,
      lead_id: bookingId || undefined,
      page: VasPages.TRAVEL_VISA_ASSISTANCE_COUNTRY_SELECTION_PAGE,
      from_page: VasPages.TRAVEL_HOMEPAGE,
      ...payload,
    },
    userDetails
  );
};

export const sendTravelPassEvents = (
  eN: string,
  payload: any = {},
  eT = EventType.VIEW,
  userDetails
) => {
  sendSegmentEvent(
    eT,
    eN,
    {
      journey: DOMESTIC_PASS.JOURNEY,
      sub_product_name: DOMESTIC_PASS.SUB_PRODUCT_NAME,
      from_page: TravelPassPages.TRAVEL_HOMEPAGE,
      ...payload,
    },
    userDetails
  );
};

export const sendAppsFlyerEvents = (actionName: string, payload = {}) => {
  if (typeof window !== 'undefined' && !!window?.flutter_inappwebview) {
    const urlParams = new URLSearchParams(window?.location?.search);
    const isApp = urlParams?.get('platform')?.includes('app');

    if (isApp) {
      const data = {
        action: AppsFlyer.ACTION,
        action_value: {
          destination: AppsFlyer.DESTINATION,
          event_name: actionName,
          event_params: [
            {
              device_id: Cookies?.get('trackerid'),
              ...payload,
              ...getUtmParams(),
            },
          ],
        },
      };
      window?.flutter_inappwebview?.callHandler(
        'WebViewConnect',
        JSON.stringify(data)
      );
    }
  }
};

export const sendPartnerEvents = (payload = {}) => {
  if (typeof window !== 'undefined' && !!window?.dapTracker) {
    const { source, medium, campaign } = HindustanTimesPartner;
    const data = {
      source,
      medium,
      campaign,
      type: HindustanTimesPartner?.type?.leadSubmit,
      trackerId: Cookies?.get('trackerid'),
      ...payload,
    };

    window?.dapTracker?.track(
      HindustanTimesPartner.action,
      data,
      HindustanTimesPartner.event
    );
  }
};
